export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7903.478a3278.jpg";